import { DimensionSharedCost } from "@/services/cloudchipr.api";

export const convertSharedCostsArrayToObjectByIds = (
  sharedCosts: DimensionSharedCost[],
) => {
  return sharedCosts?.reduce(
    (acc, sharedCost) => {
      acc[sharedCost.id] = sharedCost;
      return acc;
    },
    {} as Record<string, DimensionSharedCost>,
  );
};
